import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getPalette } from './ColorPalette';

// Import the same backdrop image
import backdropImage1 from './images/BackdropNight.png';

const SupportRequest = () => {
    const navigate = useNavigate();
    const colors = getPalette('dark'); // You can change this to 'light' or 'auto' as needed
    
    const [formData, setFormData] = useState({
        email: '',
        category: 'bug-report',
        description: '',
    });

    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Enhanced validation
        if (!formData.email.includes('@')) {
            setError('Please enter a valid email address.');
            return;
        }

        if (formData.description.trim().length < 10) {
            setError('Please provide a more detailed description (at least 10 characters).');
            return;
        }

        setError('');
        setSubmitted(false);
        setIsSubmitting(true);

        try {
            // Construct a FormData object
            const data = new FormData();
            data.append('email', formData.email);
            data.append('category', formData.category);
            data.append('description', formData.description);

            // Optional hidden fields
            data.append('_subject', 'Support Request Submission');
            data.append('_captcha', 'false');

            const response = await fetch('https://formsubmit.co/contact@flashfluency.net', {
                method: 'POST',
                body: data,
            });

            if (!response.ok) {
                throw new Error(`Form submission error: ${response.statusText}`);
            }

            console.log('Support Request Sent:', formData);
            setSubmitted(true);
            
            // Reset form after successful submission
            setTimeout(() => {
                setFormData({
                    email: '',
                    category: 'bug-report',
                    description: '',
                });
            }, 2000);
        } catch (err) {
            setError('Error sending form. Please try again.');
            console.error('Error sending form:', err);
        } finally {
            setIsSubmitting(false);
        }
    };

    const categoryOptions = [
        { value: 'bug-report', label: '🐛 Bug Report', description: 'Something isn\'t working correctly' },
        { value: 'report-abuse', label: '⚠️ Report Abuse', description: 'Report inappropriate content or behavior' },
        { value: 'cannot-access-account', label: '🔒 Account Access', description: 'I cannot access my account' },
        { value: 'purchase-issue', label: '💳 Purchase Issue', description: 'Billing or subscription problems' },
        { value: 'account-deletion', label: '🗑️ Account Deletion', description: 'Request to delete my account' },
        { value: 'feature-request', label: '💡 Feature Request', description: 'Suggest a new feature' },
        { value: 'other', label: '❓ Other', description: 'Something else' }
    ];

    return (
        <div
            style={{
                minHeight: '100vh',
                backgroundImage: `url(${backdropImage1})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundAttachment: 'fixed',
                backgroundColor: colors.background,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '20px 10px'
            }}
        >
            <div
                style={{
                    width: '100%',
                    maxWidth: '600px',
                    backgroundColor: colors.container,
                    borderRadius: '16px',
                    boxShadow: `0 8px 32px ${colors.shadow}`,
                    overflow: 'hidden'
                }}
            >
                <div
                    style={{
                        padding: '32px'
                    }}
                >

                    {submitted ? (
                        <div
                            style={{
                                backgroundColor: colors.progressBarFg + '20',
                                color: colors.progressBarFg,
                                padding: '32px',
                                borderRadius: '16px',
                                textAlign: 'center',
                                boxShadow: `0 4px 16px ${colors.shadow}`,
                                border: `2px solid ${colors.progressBarFg}40`
                            }}
                        >
                            <div
                                style={{
                                    fontSize: '64px',
                                    marginBottom: '16px'
                                }}
                            >
                                ✅
                            </div>
                            <h3
                                style={{
                                    margin: '0 0 12px 0',
                                    fontSize: '24px',
                                    fontWeight: '700',
                                    color: colors.text
                                }}
                            >
                                Request Submitted!
                            </h3>
                            <p
                                style={{
                                    margin: '0 0 24px 0',
                                    fontSize: '16px',
                                    color: colors.text,
                                    opacity: 0.8
                                }}
                            >
                                Thank you for contacting us. We'll get back to you within 24 hours.
                            </p>
                            <button
                                onClick={() => navigate('/')}
                                style={{
                                    backgroundColor: colors.button,
                                    color: '#FFFFFF',
                                    border: 'none',
                                    padding: '12px 24px',
                                    borderRadius: '8px',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.transform = 'translateY(-2px)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.transform = 'translateY(0)';
                                }}
                            >
                                Return Home
                            </button>
                        </div>
                    ) : (
                        <div
                            style={{
                                backgroundColor: colors.container,
                                padding: '32px',
                                borderRadius: '16px',
                                border: `1px solid ${colors.borderSilver}`,
                                boxShadow: `0 2px 8px ${colors.shadow}`
                            }}
                        >
                            <h3
                                style={{
                                    margin: '0 0 24px 0',
                                    fontSize: '20px',
                                    fontWeight: '600',
                                    color: colors.text,
                                    textAlign: 'center'
                                }}
                            >
                                📝 Send us a message
                            </h3>

                            <form 
                                onSubmit={handleSubmit} 
                                style={{ 
                                    display: 'flex', 
                                    flexDirection: 'column', 
                                    gap: '24px' 
                                }}
                            >
                                <div>
                                    <label
                                        style={{
                                            display: 'block',
                                            color: colors.text,
                                            fontWeight: '600',
                                            marginBottom: '8px',
                                            fontSize: '16px'
                                        }}
                                    >
                                        📧 Email Address
                                    </label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                        style={{
                                            width: '100%',
                                            padding: '16px',
                                            border: `2px solid ${colors.borderSilver}`,
                                            borderRadius: '12px',
                                            fontSize: '16px',
                                            backgroundColor: colors.background,
                                            color: colors.text,
                                            boxSizing: 'border-box',
                                            transition: 'border-color 0.2s ease',
                                            outline: 'none'
                                        }}
                                        placeholder="your.email@example.com"
                                        onFocus={(e) => e.target.style.borderColor = colors.button}
                                        onBlur={(e) => e.target.style.borderColor = colors.borderSilver}
                                    />
                                </div>

                                <div>
                                    <label
                                        style={{
                                            display: 'block',
                                            color: colors.text,
                                            fontWeight: '600',
                                            marginBottom: '8px',
                                            fontSize: '16px'
                                        }}
                                    >
                                        📋 Issue Category
                                    </label>
                                    <select
                                        name="category"
                                        value={formData.category}
                                        onChange={handleChange}
                                        style={{
                                            width: '100%',
                                            padding: '16px',
                                            border: `2px solid ${colors.borderSilver}`,
                                            borderRadius: '12px',
                                            fontSize: '16px',
                                            backgroundColor: colors.background,
                                            color: colors.text,
                                            boxSizing: 'border-box',
                                            cursor: 'pointer',
                                            outline: 'none'
                                        }}
                                        onFocus={(e) => e.target.style.borderColor = colors.button}
                                        onBlur={(e) => e.target.style.borderColor = colors.borderSilver}
                                    >
                                        {categoryOptions.map(option => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                    <p
                                        style={{
                                            fontSize: '14px',
                                            color: colors.text,
                                            opacity: 0.6,
                                            margin: '8px 0 0 0',
                                            fontStyle: 'italic'
                                        }}
                                    >
                                        {categoryOptions.find(opt => opt.value === formData.category)?.description}
                                    </p>
                                </div>

                                <div>
                                    <label
                                        style={{
                                            display: 'block',
                                            color: colors.text,
                                            fontWeight: '600',
                                            marginBottom: '8px',
                                            fontSize: '16px'
                                        }}
                                    >
                                        💬 Description
                                    </label>
                                    <textarea
                                        name="description"
                                        value={formData.description}
                                        onChange={handleChange}
                                        required
                                        style={{
                                            width: '100%',
                                            padding: '16px',
                                            border: `2px solid ${colors.borderSilver}`,
                                            borderRadius: '12px',
                                            fontSize: '16px',
                                            backgroundColor: colors.background,
                                            color: colors.text,
                                            minHeight: '120px',
                                            resize: 'vertical',
                                            boxSizing: 'border-box',
                                            fontFamily: 'inherit',
                                            outline: 'none',
                                            lineHeight: '1.5'
                                        }}
                                        placeholder="Please describe your issue in detail. Include steps to reproduce if it's a bug, or any relevant information that might help us assist you better..."
                                        rows="4"
                                        onFocus={(e) => e.target.style.borderColor = colors.button}
                                        onBlur={(e) => e.target.style.borderColor = colors.borderSilver}
                                    />
                                    <p
                                        style={{
                                            fontSize: '14px',
                                            color: colors.text,
                                            opacity: 0.6,
                                            margin: '8px 0 0 0',
                                            textAlign: 'right'
                                        }}
                                    >
                                        {formData.description.length} characters
                                    </p>
                                </div>

                                {error && (
                                    <div
                                        style={{
                                            backgroundColor: colors.lightRed,
                                            color: '#8B0000',
                                            padding: '16px',
                                            borderRadius: '12px',
                                            fontSize: '15px',
                                            border: '1px solid #FF6B6B',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px'
                                        }}
                                    >
                                        <span>⚠️</span>
                                        {error}
                                    </div>
                                )}

                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    style={{
                                        width: '100%',
                                        padding: '18px',
                                        backgroundColor: isSubmitting ? colors.borderSilver : colors.button,
                                        color: '#FFFFFF',
                                        border: 'none',
                                        borderRadius: '12px',
                                        fontSize: '18px',
                                        fontWeight: '600',
                                        cursor: isSubmitting ? 'not-allowed' : 'pointer',
                                        boxShadow: isSubmitting ? 'none' : `0 4px 16px ${colors.shadow}`,
                                        transition: 'all 0.3s ease',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '12px',
                                        opacity: isSubmitting ? 0.7 : 1
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!isSubmitting) {
                                            e.target.style.transform = 'translateY(-2px)';
                                            e.target.style.boxShadow = `0 6px 20px ${colors.shadow}`;
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!isSubmitting) {
                                            e.target.style.transform = 'translateY(0)';
                                            e.target.style.boxShadow = `0 4px 16px ${colors.shadow}`;
                                        }
                                    }}
                                >
                                    {isSubmitting ? (
                                        <>
                                            <span style={{ fontSize: '16px' }}>⏳</span>
                                            Sending Request...
                                        </>
                                    ) : (
                                        <>
                                            <span style={{ fontSize: '18px' }}>🚀</span>
                                            Submit Request
                                        </>
                                    )}
                                </button>
                            </form>
                        </div>
                    )}

                    {!submitted && (
                        <div
                            style={{
                                textAlign: 'center',
                                marginTop: '24px'
                            }}
                        >
                            <button
                                onClick={() => navigate('/')}
                                style={{
                                    backgroundColor: 'transparent',
                                    color: colors.text,
                                    border: `2px solid ${colors.borderSilver}`,
                                    padding: '12px 24px',
                                    borderRadius: '8px',
                                    fontSize: '16px',
                                    fontWeight: '500',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    opacity: 0.8
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = colors.highlight;
                                    e.target.style.borderColor = colors.button;
                                    e.target.style.opacity = '1';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = 'transparent';
                                    e.target.style.borderColor = colors.borderSilver;
                                    e.target.style.opacity = '0.8';
                                }}
                            >
                                ← Back to Home
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SupportRequest;